<template>
  <div>
    <static-fullscreen-card v-show="!idItemShow">
      <template v-slot:header></template>
      <template v-slot:actions>
        <a-btn-add :icon="'far fa-question-circle'" :title="'Лист ожидания'" @click="showList()" />
        <a-btn-refresh @click="$refs.table.updateData()" />
        <a-btn-add :icon="'far fa-plus-square'" :title="'Создать документ'" v-if="getAccess('documents.goodsIncome.create')" @click="createNew()" />
      </template>
      <portal to="v-main">
        <create-dialog v-model="showEditDialog" v-if="showEditDialog" :api="url" :m="m" :id="idEdit" :details="details"></create-dialog>
        <add-Goods v-if="showDialogAddGoods" v-model="showDialogAddGoods" :object_id="null" :order_id="null" :type="'addFromList'" @save="createDocIncome($event)" />
      </portal>
      <a-table-f-api
        ref="table"
        :api="url"
        :model="getModelList(m)"
        :useQuery="false"
        :defaults="defaults"
        :selectedRows="selectedRows"
        @click="
          counter += 1;
          onDetectClick($event);
        "
      >
      </a-table-f-api>
      <popup-window v-if="infoSnack" :type="3" :data="infoData" :model="infoModel" />
    </static-fullscreen-card>
    <ViewItem v-if="idItemShow" :idShow="idItemShow" @close="itemShowClose($event)" />
  </div>
</template>

<script>
import { getAccess, genModel, doubleClickDetect, keyDetect } from "@/components/mixings";
//goodsMovingCreateDialog
export default {
  mixins: [getAccess, genModel, doubleClickDetect, keyDetect],
  components: {
    ViewItem: () => import("./views/goodsIncomeView"),
    addGoods: () => import("./dialogs/incomeAddGoodsDialog"),
    createDialog: () => import("./dialogs/goodsIncomeCreateDialog"),
  },
  data() {
    return {
      idEdit: 0,
      details: null,
      idItemShow: 0,
      showEditDialog: false,
      showDialogAddGoods: false,
      title: "",
      m: this.$store.getters["config/get"].models.documentGoodsIncome,
      url: "/accounting/doc/goods_income",
      defaults: {
        sort: { key: "date_doc", order: "DESC" },
        paramName: "documentGoodsMoving",
      },
      infoData: null,
      infoModel: null,
    };
  },
  created() {
    this.$root.title = "Приемка товаров";
  },
  computed: {
    permit() {
      return this.getAccess("menu.documentGoodsIncome");
    },
    infoSnack() {
      if (this.keysModified) {
      }
      let res = this.keys?.ctrl;
      this.infoData = null;
      this.infoModel = null;
      if (res) this.showOrderDetail();
      return res;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
  },
  methods: {
    itemShowClose() {
      this.loading = true;
      this.$refs.table.updateRowData(this.idItemShow);
      this.loading = !true;
      this.idItemShow = 0;
    },
    onSingleClick(d) {},
    onDoubleClick(d) {
      this.onClickRow(d);
    },
    async onClickRow(d) {
      this.idItemShow = d.row.id;
    },
    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.details = null;
      this.showEditDialog = true;
    },
    showList() {
      this.showDialogAddGoods = true;
    },
    createDocIncome(details) {
      this.idEdit = 0;
      this.details = details;
      this.showEditDialog = true;
    },
    async showOrderDetail() {
      let id = this.selectedRows[0];
      if (!id) return;
      let data;
      let model;
      const d = await this.$axios.get(this.url + "/" + id);
      if (d.data && d.data.data) {
        let data = d.data.data.data_table;

        model = this.m.listDetail.filter((el) => ["_jm_accounting_doc_order_goods_table_1_name", "amount", "value"].includes(el.name));
        this.infoData = data;
        this.infoModel = model;
      }
    },
  },
};
</script>
